module.exports = __webpack_public_path__ + "web/img/integral_zh.cae9f4ba.png";